import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const CustomerReviews = () => {
  const reviews = [
  {
    id: 1,
    name: "Sarah Johnson",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1c10fb07b-1763299083921.png",
    avatarAlt: "Professional headshot of African woman with warm smile wearing yellow traditional dress and colorful headwrap against neutral background",
    rating: 5,
    review: "Best chapati in Juba! The quality is consistent and delivery is always on time. My family orders from Chapati Plus every week.",
    date: "2 days ago"
  },
  {
    id: 2,
    name: "Michael Deng",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_11c880ebf-1763293139508.png",
    avatarAlt: "Professional headshot of African man with friendly expression wearing white collared shirt against light blue background",
    rating: 5,
    review: "The WhatsApp ordering system is so convenient! Food arrives hot and fresh. Their mixed grill platter is absolutely delicious.",
    date: "1 week ago"
  },
  {
    id: 3,
    name: "Grace Akol",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_14159f8e4-1763298358429.png",
    avatarAlt: "Professional headshot of young African woman with bright smile wearing red blouse and gold earrings against white background",
    rating: 5,
    review: "Authentic flavors with modern service. The staff is friendly and the food quality is excellent. Highly recommend!",
    date: "2 weeks ago"
  }];


  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) =>
    <Icon
      key={index}
      name={index < rating ? "Star" : "Star"}
      size={16}
      color={index < rating ? "var(--color-secondary)" : "var(--color-muted)"}
      className={index < rating ? "fill-current" : ""} />

    );
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-muted">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            What Our Customers Say
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Join thousands of satisfied customers who trust Chapati Plus for quality meals
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {reviews?.map((review) =>
          <div
            key={review?.id}
            className="bg-card rounded-lg p-5 md:p-6 shadow-md hover:shadow-lg transition-shadow duration-300">

              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full overflow-hidden flex-shrink-0">
                  <Image
                  src={review?.avatar}
                  alt={review?.avatarAlt}
                  className="w-full h-full object-cover" />

                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="text-base md:text-lg font-semibold text-foreground truncate">
                    {review?.name}
                  </h3>
                  <div className="flex items-center gap-1 mt-1">
                    {renderStars(review?.rating)}
                  </div>
                </div>
              </div>

              <p className="text-sm md:text-base text-muted-foreground mb-3 line-clamp-3">
                {review?.review}
              </p>

              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <Icon name="Clock" size={14} />
                <span>{review?.date}</span>
              </div>
            </div>
          )}
        </div>

        <div className="text-center mt-8 md:mt-12">
          <div className="inline-flex items-center gap-2 bg-card px-6 py-3 rounded-full shadow-md">
            <Icon name="Star" size={20} color="var(--color-secondary)" className="fill-current" />
            <span className="text-lg md:text-xl font-bold text-foreground">4.9/5.0</span>
            <span className="text-sm text-muted-foreground">from 500+ reviews</span>
          </div>
        </div>
      </div>
    </section>);

};

export default CustomerReviews;